import i18n from "i18next"
import { initReactI18next } from "react-i18next"

// Import translations
import enTranslation from "./locales/en/translation.json"
import hiTranslation from "./locales/hi/translation.json"

// Initialize i18next
i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslation,
    },
    hi: {
      translation: hiTranslation,
    },
  },
  fallbackLng: "en",
  debug: process.env.NODE_ENV === "development",

  interpolation: {
    escapeValue: false, // React already escapes values
  },

  // No automatic language detection
})

// Function to initialize language from localStorage
export const initLanguage = () => {
  const language = localStorage.getItem("language")
  if (language) {
    i18n.changeLanguage(language)
  }
}

export default i18n
